import { useTranslation } from 'react-i18next';
import { useUserStore } from 'src/store/user-store';
import { useAvailableSites } from './api/use-available-sites';

export const useViewContextName = () => {
  const { t } = useTranslation();

  const { viewContext, directoryToken } = useUserStore();

  const { data: availableSites } = useAvailableSites();

  const selectedSite = availableSites?.resources.find(
    site => site.token === directoryToken,
  );

  const getViewContextName = () => {
    switch (viewContext) {
      case 'site':
        return t('common:viewContextSelector.siteWithName', {
          siteName: selectedSite?.name,
        });

      default:
        return t('common:viewContextSelector.placeholder');
    }
  };

  return getViewContextName;
};
